import * as React from 'react';

export interface IconFeature {
    url: string;
    text: string;
}

export interface MfrmProductDetailsSpecificationProps {
    iconFeatures: IconFeature[];
    listedFeatures: string[];
    heading2: string[];
    heading1: string[];
    mattressBreakdown: Record<string, string | string[]>;
}

export const MfrmProductDetailsSpecification = (props: MfrmProductDetailsSpecificationProps) => {
    const { listedFeatures, heading1, heading2, mattressBreakdown, iconFeatures } = props;
    const mattressBreakdownArr = mattressBreakdown && Object.entries(mattressBreakdown);
    return (
        <section className='mfrm-product-details__specifications'>
            {(listedFeatures?.length || iconFeatures?.length) && <section className='features'>
                <h1>{heading1 ? heading1 : 'Features'}</h1>
                <ul className='icons'>
                    {iconFeatures?.map((icon, i) => {
                        return (
                            <li key={i}>
                                <img src={icon?.url ?? ''} />
                                {icon?.text ?? ''}
                            </li>
                        );
                    })}
                </ul>
                {listedFeatures?.map((listedFeature, i) => {
                    return <h2 key={i}>{listedFeature ?? ''}</h2>;
                })}
            </section>
            }
            {mattressBreakdownArr?.length && <section className='breakdown'>
                <h1> {heading2 ? heading2 : 'Breakdown'}</h1>
                <dl>
                    {mattressBreakdownArr?.map(([key, values]) => {
                        return (
                            <div className='row' key={key}>
                                <dt>{key}</dt>
                                <div className='dd'>
                                    {Array.isArray(values) ? (
                                        values.map(value => {
                                            return <dd key={value} dangerouslySetInnerHTML={{__html: value}} />;
                                        })
                                    ) : (
                                        <dd dangerouslySetInnerHTML={{__html: values}} />
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </dl>
            </section>
            }
        </section>
    );
};
